import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import ScrollableAnchor from 'react-scrollable-anchor';

import Product from './Product';
import ProductSlider from './ProductsSlider';

import './SlickSlider.css';
import styles from './Products.module.css';


const settings = {
  dots: false,
  infinite: true,
  autoplaySpeed: 1000,
  autoplay: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  pauseOnHover: false,
  pauseOnFocus: false,
};
/*
Products.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      node: PropTypes.shape({

      }),
    }),
  ).isRequired,
}; */

class ProductsSlick extends Component {



  render() {
    const { data } = this.props;
    return (
      <ScrollableAnchor id={data.id}>
        <section className={styles.Products}>
          <h2>Das Produkt</h2>
          <p>{ data.text }</p>
          <div className={styles.container}>
            <ProductSlider data={data.products} />
          </div>
        </section>
      </ScrollableAnchor>
    );
  }

}

export default ProductsSlick;



// WEBPACK FOOTER //
// ./src/components/Products/ProductsSlick.js